import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Header() {
  const [activeLink, setActiveLink] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNavClick = (e, link) => {
    e.preventDefault();
    const sectionId = link.toLowerCase();
    setActiveLink(link);
    setMobileMenuOpen(false);
    
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header style={isMobile ? styles.headerMobile : styles.header}>
      <div style={styles.logo}>
        <span style={isMobile ? styles.brandNameMobile : styles.brandName}>
          {content.brand.name}
        </span>
      </div>
      
      {isMobile && (
        <button 
          style={styles.hamburger}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <div style={styles.hamburgerLine}></div>
          <div style={styles.hamburgerLine}></div>
          <div style={styles.hamburgerLine}></div>
        </button>
      )}
      
      <nav style={
        isMobile 
          ? {...styles.navMobile, ...(mobileMenuOpen ? styles.navMobileOpen : {})}
          : styles.nav
      }>
        {content.navigation.links.map((link, index) => (
          <a 
            key={index} 
            href={`#${link.toLowerCase()}`}
            style={{
              ...(isMobile ? styles.navLinkMobile : styles.navLink),
              ...(activeLink === link ? styles.navLinkActive : {})
            }}
            onClick={(e) => handleNavClick(e, link)}
          >
            {link}
          </a>
        ))}

        <a
          href={content.navigation.invest.url}
          target="_blank"
          rel="noopener noreferrer"
          style={isMobile ? styles.investLinkMobile : styles.investLink}
          onClick={() => setMobileMenuOpen(false)}
        >
          {content.navigation.invest.label}
        </a>
      </nav>
      
      {!isMobile && (
        <button style={styles.requestButton}>
          {content.buttons.requestNDA}
        </button>
      )}
    </header>
  );
}

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 60px',
    backgroundColor: colors.white,
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  headerMobile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 20px',
    backgroundColor: colors.white,
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    flexWrap: 'wrap',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  brandName: {
    fontSize: '18px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
  },
  brandNameMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
  },
  navMobile: {
    display: 'none',
    flexDirection: 'column',
    width: '100%',
    gap: '0',
    backgroundColor: colors.white,
    padding: '0',
    marginTop: '10px',
  },
  navMobileOpen: {
    display: 'flex',
  },
  navLink: {
    fontSize: '16px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  },
  navLinkMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    padding: '15px 0',
    borderBottom: '1px solid #f0f0f0',
  },
  navLinkActive: {
    color: colors.primary,
    fontWeight: fontWeights.semibold,
  },
  requestButton: {
    padding: '10px 24px',
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    cursor: 'pointer',
  },
  hamburger: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '5px',
  },
  
  hamburgerLine: {
    width: '25px',
    height: '3px',
    backgroundColor: colors.textPrimary,
    borderRadius: '2px',
  },
  requestButton: {
    display: 'none',  // Add this line
    padding: '10px 24px',
    // ... rest of the styles
  },
  investLink: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1,
    fontSize: '16px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.white,
    backgroundColor: colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    padding: '10px 20px',
    borderRadius: '6px',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.3s ease',
  },
  investLinkMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.white,
    backgroundColor: colors.primary,
    textDecoration: 'none',
    cursor: 'pointer',
    padding: '15px 0',
    borderRadius: '6px',
    textAlign: 'center',
    marginTop: '15px',
  },
};

export default Header;